import React from "react";
import { ColoredEventCube } from "./CalendarDay";
import styled from "styled-components";

type CalendarLegendIconProps = {
  label: string;
  color: string;
};

const StyledLabel = styled.div.attrs({ className: "legend-label" })`
  color: #86888b;
  font-family: Rubik;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-left: 0.5rem;
`;

const CalendarLegendIconWrapper = styled.div.attrs({ className: "legend-icon-wrapper" })`
  display: flex;
  align-items: center;
  padding: 0.25rem;
`;

const CalendarLegendIcon: React.FC<CalendarLegendIconProps> = ({ label, color }) => {
  return (
    <CalendarLegendIconWrapper>
      <ColoredEventCube color={color}></ColoredEventCube>
      <StyledLabel>{label}</StyledLabel>
    </CalendarLegendIconWrapper>
  );
};

export default CalendarLegendIcon;
